import "@tento-ui/components/list/list-cell-layout";

import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { Link } from "@tento-ui/components/link/link";

@component({
  name: "lona-marketing-footer",
})
export class MarketingFooter extends LonaWebComponent {
  private $cell = this.hydrate("cell");

  static $styles = [
    Link.$style,
    css`
      :host {
        width: 100%;
      }

      a,
      a:visited {
        color: var(--mkt-footer-fg, var(--text-pri));
      }

      #root {
        padding: 12px 20px;
        max-width: var(--max-width);
        box-sizing: border-box;
        margin-left: auto;
        margin-right: auto;
      }

      #cell {
        display: block;
        margin-left: -8px;
      }

      .footer-link {
        position: relative;
        margin-left: 24px;
        color: var(--mkt-footer-fg, #444);
        --font-size: var(--small-size);
      }

      .footer-link:visited {
        color: var(--mkt-footer-fg, #444);
      }

      .footer-link:not(:first-of-type)::before {
        content: "";
        position: absolute;
        /* width: 1px; */
        left: -12px;
        top: 0px;
        bottom: 0px;
        border-left: 1px solid var(--mkt-footer-rule, black);
      }

      .list-cell-icon {
        height: 32px;
        width: 32px;
        border-radius: 16px;
        background: #888;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <div id="root">
      <div class="content-body">
        <std-row
          style="align-items: center; color: var(--mkt-footer-fg, #444); flex-wrap: wrap; gap: 12px;"
        >
          <!-- Profile List Cell -->

          <a target="_blank" href="http://jameskao.io">
            <std-list-cell-layout id="cell">
              <div slot="icon" class="list-cell-icon"></div>
              <std-col slot="content" style="margin-top:3px;padding-right:4px;">
                <p style="margin-bottom: 3px;" class="small">
                  Come say hi 😄 - @yuzuquat
                </p>

                <p class="small">
                  <span style="padding-top: 4px; padding-right: 4px;">©</span
                  >2026
                </p>
              </std-col>
            </std-list-cell-layout>
          </a>

          <std-spacer></std-spacer>
          <div>
            <a
              class="footer-link"
              target="_blank"
              href="/tos"
              style="margin-left: 0px;"
              >Terms of Service</a
            >
            <a class="footer-link" target="_blank" href="/privacy-policy"
              >Privacy Policy</a
            >
          </div>
        </std-row>
      </div>
    </div>
  `;
}
